import { useFitContentWidth } from "../../../../../logic/hooks/useFitContentWidth";
import "./LauncherLabel.scss";

interface LauncherLabelProps {
    text: string;
}

export function LauncherLabel({ text }: LauncherLabelProps) {
    const { containerRef, contentRef } = useFitContentWidth(text);

    return (
        <span className="launcher-label" ref={containerRef} dir="auto">
            <span className="launcher-label__text" ref={contentRef}>
                {text}
            </span>
        </span>
    );
}
